import type { SVGProps } from "react";

export default function DeltaReactionIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="12"
      height="11"
      viewBox="0 0 12 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        id="Polygon 3"
        d="M6 1.28885L10.2056 9.7H1.79443L6 1.28885Z"
        stroke="currentColor"
        strokeWidth="1.6"
      />
    </svg>
  );
}
